// extracted by mini-css-extract-plugin
export default {"content":"confirm_content__XGUAx"};